import Skeleton from "@/components/atoms/Skeleton/Skeleton";
import { cn } from "@/utils/cn";
import React from "react";

type LivescoreSkeletonProps = React.AllHTMLAttributes<HTMLDivElement> & {
  items: number;
};

const LivescoreSkeleton = ({
  items,
  className,
  ...props
}: LivescoreSkeletonProps) => {
  const arr = Array.from({ length: items }, (_, i) => i);
  return (
    <>
      {arr.map((item) => (
        <li
          key={`livescore-skeleton-${item}`}
          className="animate-fade-in"
        >
          <Skeleton
            className={cn("rounded-lg w-full h-[72px]", className)}
            {...props}
          />
        </li>
      ))}
    </>
  );
};

export default LivescoreSkeleton;
